export enum GenderType {
        Male = 0,
        Female = 1
}

export class PatientModel {
        public id: string;
        public userName: string;
        public patientREF: string;
        public titleId: string = null;
        public firstName: string;
        public middleName: string;
        public surName: string;
        public sexId: string = null;
        public sexName: string;
        public dateOfBirth: any;
        public email: string;
        public address1: string;
        public address2: string;
        public address3: string;
        public postCode: string;
        public countryId: string = null;
        public countryName: string;
        public homePhone: string;
        public workPhone: string;
        public mobilePhone: string;
        public countryOfBirthId: string = null;
        public countryOfBirthName: string;
        public occupationId: string = null;
        public occupationName: string = null;
        public partyTypeId: string = null;
        public partyTypeName: string;
        public partyId: string = null;
        public partyName: string;
        public college: string = null;
        public studentId: string;
        public healthInsuranceId: string = null;
        public healthPolicyNumber: string;
        public policyNumber: string;
        public marketingId: string  = null;
        public isCreateMyTMBAccount: boolean;
        public sendActivationEmail: boolean;
        public isEnableCreateMyTMBAccount: boolean;
        public isIncludeInMarketing: boolean;
        public isSeparateBillingAddress: boolean;
        public isDeceased: boolean;
        public isActive: boolean;
        public isDisable: boolean;
        public billingAddress1 = '';
        public billingAddress2 = '';
        public billingAddress3 = '';
        public billingPostCode = '';
        public billingCountryId: string = null;
        public billingCountryName: string = null;
        public passportOrIdNumber: string;
        public isManuallyActive: boolean;
        public myTmbPassword: string;
}
export enum PatientVaccineVisit {
        Past = 0,
        Current = 1,
        Next = 2,
    }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/models/consultation/patient.model.ts